export default __webpack_public_path__ + "static/media/kn_logo_white.3b9634a2.svg";